import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import CommonAmh from './locales/amh/common.json';
import LabelsAmh from './locales/amh/labels.json';
import LocaleAmh from './locales/amh/locale.json';
import ResourceAmh from './locales/amh/resource.json';
import ValidationAmh from './locales/amh/validation.json';
import CommonAr from './locales/ar/common.json';
import LabelsAr from './locales/ar/labels.json';
import LocaleAr from './locales/ar/locale.json';
import ResourceAr from './locales/ar/resource.json';
import ValidationAr from './locales/ar/validation.json';
import CommonDe from './locales/de/common.json';
import LabelsDe from './locales/de/labels.json';
import LocaleDe from './locales/de/locale.json';
import ResourceDe from './locales/de/resource.json';
import ValidationDe from './locales/de/validation.json';
import CommonEn from './locales/en/common.json';
import LabelsEn from './locales/en/labels.json';
import LocalenEn from './locales/en/locale.json';
import QuestionsEn from './locales/en/questions.json';
import ResourceEn from './locales/en/resource.json';
import ValidationEn from './locales/en/validation.json';
import CommonEs from './locales/es/common.json';
import LabelsEs from './locales/es/labels.json';
import LocalenEs from './locales/es/locale.json';
import ResourceEs from './locales/es/resource.json';
import ValidationEs from './locales/es/validation.json';
import CommonEsBo from './locales/es-BO/common.json';
import LabelsEsBo from './locales/es-BO/labels.json';
import LocalenEsBo from './locales/es-BO/locale.json';
import ResourceEsBo from './locales/es-BO/resource.json';
import ValidationEsBo from './locales/es-BO/validation.json';
import CommonEsEs from './locales/es-ES/common.json';
import LabelsEsEs from './locales/es-ES/labels.json';
import LocalenEsEs from './locales/es-ES/locale.json';
import ResourceEsEs from './locales/es-ES/resource.json';
import ValidationEsEs from './locales/es-ES/validation.json';
import CommonEt from './locales/et/common.json';
import LabelsEt from './locales/et/labels.json';
import LocalenEt from './locales/et/locale.json';
import QuestionsEt from './locales/et/questions.json';
import ResourceEt from './locales/et/resource.json';
import ValidationEt from './locales/et/validation.json';
import CommonFr from './locales/fr/common.json';
import LabelsFr from './locales/fr/labels.json';
import LocalenFr from './locales/fr/locale.json';
import ResourceFr from './locales/fr/resource.json';
import ValidationFr from './locales/fr/validation.json';
import CommonId from './locales/id/common.json';
import LabelsId from './locales/id/labels.json';
import LocalenId from './locales/id/locale.json';
import QuestionsId from './locales/id/questions.json';
import ResourceId from './locales/id/resource.json';
import ValidationId from './locales/id/validation.json';
import CommonIt from './locales/it/common.json';
import LabelsIt from './locales/it/labels.json';
import LocalenIt from './locales/it/locale.json';
import ResourceIt from './locales/it/resource.json';
import ValidationIt from './locales/it/validation.json';
import CommonJa from './locales/ja/common.json';
import LabelsJa from './locales/ja/labels.json';
import LocalenJa from './locales/ja/locale.json';
import ResourceJa from './locales/ja/resource.json';
import ValidationJa from './locales/ja/validation.json';
import CommonKm from './locales/km/common.json';
import LabelsKm from './locales/km/labels.json';
import LocalenKm from './locales/km/locale.json';
import ResourceKm from './locales/km/resource.json';
import ValidationKm from './locales/km/validation.json';
import CommonLo from './locales/lo/common.json';
import LabelsLo from './locales/lo/labels.json';
import LocalenLo from './locales/lo/locale.json';
import QuestionsLo from './locales/lo/questions.json';
import ResourceLo from './locales/lo/resource.json';
import ValidationLo from './locales/lo/validation.json';
import CommonNl from './locales/nl/common.json';
import LabelsNl from './locales/nl/labels.json';
import LocalenNl from './locales/nl/locale.json';
import ResourceNl from './locales/nl/resource.json';
import ValidationNl from './locales/nl/validation.json';
import CommonPl from './locales/pl/common.json';
import LabelsPl from './locales/pl/labels.json';
import LocalenPl from './locales/pl/locale.json';
import ResourcePl from './locales/pl/resource.json';
import ValidationPl from './locales/pl/validation.json';
import CommonPt from './locales/pt/common.json';
import LabelsPt from './locales/pt/labels.json';
import LocalenPt from './locales/pt/locale.json';
import QuestionsPt from './locales/pt/questions.json';
import ResourcePt from './locales/pt/resource.json';
import ValidationPt from './locales/pt/validation.json';
import CommonRo from './locales/ro/common.json';
import LabelsRo from './locales/ro/labels.json';
import LocalenRo from './locales/ro/locale.json';
import ResourceRo from './locales/ro/resource.json';
import ValidationRo from './locales/ro/validation.json';
import CommonRu from './locales/ru/common.json';
import LabelsRu from './locales/ru/labels.json';
import LocalenRu from './locales/ru/locale.json';
import ResourceRu from './locales/ru/resource.json';
import ValidationRu from './locales/ru/validation.json';
import CommonVi from './locales/vi/common.json';
import LabelsVi from './locales/vi/labels.json';
import LocalenVi from './locales/vi/locale.json';
import QuestionsVi from './locales/vi/questions.json';
import ResourceVi from './locales/vi/resource.json';
import ValidationVi from './locales/vi/validation.json';
import CommonZh from './locales/zh/common.json';
import LabelsZh from './locales/zh/labels.json';
import LocalenZh from './locales/zh/locale.json';
import ResourceZh from './locales/zh/resource.json';
import ValidationZh from './locales/zh/validation.json';
import CommonZhTw from './locales/zh-TW/common.json';
import LabelsZhTw from './locales/zh-TW/labels.json';
import LocalenZhTw from './locales/zh-TW/locale.json';
import ResourceZhTw from './locales/zh-TW/resource.json';
import ValidationZhTw from './locales/zh-TW/validation.json';

const ns = ['locale', 'resource', 'labels', 'validation', 'common'];
const supportedLngs = [
  'amh',
  'ar',
  'de',
  'et',
  'en',
  'es',
  'es-ES',
  'es-BO',
  'fr',
  'id',
  'it',
  'ja',
  'km',
  'lo',
  'nl',
  'pl',
  'pt',
  'ro',
  'ru',
  'vi',
  'zh',
  'zh-TW',
];

const resources = {
  'amh': {
    common: CommonAmh,
    labels: LabelsAmh,
    locales: LocaleAmh,
    resource: ResourceAmh,
    validation: ValidationAmh,
  },
  'ar': {
    common: CommonAr,
    labels: LabelsAr,
    locales: LocaleAr,
    resource: ResourceAr,
    validation: ValidationAr,
  },
  'de': {
    common: CommonDe,
    labels: LabelsDe,
    locales: LocaleDe,
    resource: ResourceDe,
    validation: ValidationDe,
  },
  'en': {
    common: CommonEn,
    labels: LabelsEn,
    locales: LocalenEn,
    questions: QuestionsEn,
    resource: ResourceEn,
    validation: ValidationEn,
  },
  'es': {
    common: CommonEs,
    labels: LabelsEs,
    locales: LocalenEs,
    resource: ResourceEs,
    validation: ValidationEs,
  },
  'es-BO': {
    common: CommonEsBo,
    labels: LabelsEsBo,
    locales: LocalenEsBo,
    resource: ResourceEsBo,
    validation: ValidationEsBo,
  },
  'es-ES': {
    common: CommonEsEs,
    labels: LabelsEsEs,
    locales: LocalenEsEs,
    resource: ResourceEsEs,
    validation: ValidationEsEs,
  },
  'et': {
    common: CommonEt,
    labels: LabelsEt,
    locales: LocalenEt,
    questions: QuestionsEt,
    resource: ResourceEt,
    validation: ValidationEt,
  },
  'fr': {
    common: CommonFr,
    labels: LabelsFr,
    locales: LocalenFr,
    resource: ResourceFr,
    validation: ValidationFr,
  },
  'id': {
    common: CommonId,
    labels: LabelsId,
    locales: LocalenId,
    questions: QuestionsId,
    resource: ResourceId,
    validation: ValidationId,
  },
  'it': {
    common: CommonIt,
    labels: LabelsIt,
    locales: LocalenIt,
    resource: ResourceIt,
    validation: ValidationIt,
  },
  'ja': {
    common: CommonJa,
    labels: LabelsJa,
    locales: LocalenJa,
    resource: ResourceJa,
    validation: ValidationJa,
  },
  'km': {
    common: CommonKm,
    labels: LabelsKm,
    locales: LocalenKm,
    resource: ResourceKm,
    validation: ValidationKm,
  },
  'lo': {
    common: CommonLo,
    labels: LabelsLo,
    locales: LocalenLo,
    questions: QuestionsLo,
    resource: ResourceLo,
    validation: ValidationLo,
  },
  'nl': {
    common: CommonNl,
    labels: LabelsNl,
    locales: LocalenNl,
    resource: ResourceNl,
    validation: ValidationNl,
  },
  'pl': {
    common: CommonPl,
    labels: LabelsPl,
    locales: LocalenPl,
    resource: ResourcePl,
    validation: ValidationPl,
  },
  'pt': {
    common: CommonPt,
    labels: LabelsPt,
    locales: LocalenPt,
    questions: QuestionsPt,
    resource: ResourcePt,
    validation: ValidationPt,
  },
  'ro': {
    common: CommonRo,
    labels: LabelsRo,
    locales: LocalenRo,
    resource: ResourceRo,
    validation: ValidationRo,
  },
  'ru': {
    common: CommonRu,
    labels: LabelsRu,
    locales: LocalenRu,
    resource: ResourceRu,
    validation: ValidationRu,
  },
  'vi': {
    common: CommonVi,
    labels: LabelsVi,
    locales: LocalenVi,
    questions: QuestionsVi,
    resource: ResourceVi,
    validation: ValidationVi,
  },
  'zh': {
    common: CommonZh,
    labels: LabelsZh,
    locales: LocalenZh,
    resource: ResourceZh,
    validation: ValidationZh,
  },
  'zh-TW': {
    common: CommonZhTw,
    labels: LabelsZhTw,
    locales: LocalenZhTw,
    resource: ResourceZhTw,
    validation: ValidationZhTw,
  },
};

/*

const resources = ns.reduce((acc, n) => {
  supportedLngs.forEach((lng) => {
    if (!acc[lng]) acc[lng] = {};
    acc[lng] = {
      ...acc[lng],
      // eslint-disable-next-line import/no-dynamic-require
      [n]: require(`./locales/${lng}/${n}.json`),
    };
  });
  return acc;
}, {}); */

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    detection: { caches: [] },
    resources,
    // lng: "es",
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    debug: false,
    fallbackLng: 'en',
    nonExplicitSupportedLngs: true,
    defaultNS: 'common',
    ns,
    supportedLngs,
    useLocalStorage: false,
  });

export default i18n;
